import { render, staticRenderFns } from "./Force.vue?vue&type=template&id=3853911b&"
import script from "./Force.vue?vue&type=script&lang=js&"
export * from "./Force.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports